// http://www.csvjson.com/csv2json
import { PillarModel } from "./PillarModel";

export const ContentPillarsModel: PillarModel[] = [
  {
    url: "value",
    id: 0,
    title: "Breathtaking Value",
    quote: "“show me the value!”",
    introText:
      "The Subaru XV not only enables blockbuster entertainment, it delivers show-stopping value with more of the features you want as standard. Like our legendary Symmetrical All-Wheel Drive for unprecedented grip, advanced technology like a super large touchscreen, X-Mode and so much more.",
    color: "#008079",
    menuImage: "ice-cream-384x1024.jpg",
    menuImageMobi: "ice-cream-768x370.jpg",
    fullImage: "ice-cream-1730x1024.jpg"
  },
  {
    url: "technology",
    id: 1,
    title: "Advanced Technology",
    quote: "“beam me up, Subaru!”",
    introText:
      "The Subaru XV takes technology where it’s never been before. Selected variants offer advanced features like Subaru’s world-class EyeSight® Driver Assist system that’s like an extra pair of eyes to watch the road ahead and Subaru’s Vision Assist technology with features such as blind spot monitoring, lane change assist and rear cross traffic alert.",
    color: "#213d7a",
    menuImage: "astronaut-384x1024.jpg",
    menuImageMobi: "astronaut-768x370.jpg",
    fullImage: "astronaut-1730x1024.jpg"
  },
  {
    url: "infotainment",
    id: 2,
    title: "Infotainment",
    quote: "“for lovers of the big screen”",
    introText:
      "Bold design and bright colours turn heads on the road, while a tech filled interior keeps the good times rolling inside. Be entertained with an 6.5” or 8” intuitive touchscreen infotainment system that can connect seamlessly to your smartphone so you can stream the music you love straight into the Subaru XV’s impressive sound system. We’ve covered all bases too, with plenty of USB outlets to keep all your devices charged all the time. Swipe, pinch, touch – all your entertainment is right at your fingertips.",
    color: "#e47100",
    menuImage: "cinema-384x1024.jpg",
    menuImageMobi: "cinema-768x370.jpg",
    fullImage: "cinema-1730x1024.jpg"
  },
  {
    url: "style",
    id: 3,
    title: "Sporty Style & Space",
    quote: "“ridiculously good looking”",
    introText:
      "Our designers haven’t been sitting on their hands. From roof to rim, the Subaru XV has been redesigned to make a statement. A wide and sporty stance shows off Subaru’s signature style with a classic hexagonal grille and hawk-eye headlights while the matte black cladding defines the SUV’s rugged character. Vivid new colours have been added to the range and the interior has a sleek and intuitive feel.",
    color: "#22626E",
    menuImage: "good-looking-384x1024.jpg",
    menuImageMobi: "good-looking-768x370.jpg",
    fullImage: "good-looking-1730x1024.jpg"
  },
  {
    url: "handling",
    id: 4,
    title: "Great Ride & Handling",
    quote: "“ground hug day”",
    introText:
      "Built on the Subaru Global Platform, the All-Wheel Drive Subaru XV is brilliant to the core. A new streamlined frame delivers straight-line stability, improved rigidity, more responsive control and an even quieter cabin. Chassis rigidity increases by up to 100% on the current XV, the 2.0-litre direct injection Boxer engine has been revamped to be lighter and more powerful, rough road capability is improved with X-Mode, plus so much more. The result?  The feel-good ride of the year. All-day, every day.",
    color: "#755327",
    menuImage: "groundhog-384x1024.jpg",
    menuImageMobi: "ground-hog-768x370.jpg",
    fullImage: "groundhog-1730x1024.jpg"
  }
];
